import { format } from "date-fns";
import { TOURNEY_STATUS_CANCELLED } from "@/Poker/data/Constants";
import React from "react";

function TourneyDetailsRebuyInfo({ selectedTourneyDetails }) {
  const {
    levelDuration,
    reEntryType,
    tourneyStartTime,
    rebuyWithOutAddon,
    rebuyWithAddon,
    tourneyStatus,
  } = selectedTourneyDetails;

  const InfoCard = ({ title, value, secondaryValue }) => {
    return (
      <div className="flex flex-col w-1/2 my-2 pr-4">
        <div className="text-2xs font-medium uppercase">{title}</div>
        <div className="text-sm font-bold ">{value}</div>
        {secondaryValue && <div className="text-2xs ">{secondaryValue}</div>}
      </div>
    );
  };

  const formatMinSec = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    // Pad with leading zero if needed
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");

    return `${formattedMinutes} min`;
  };

  // ReentryType: [None, RebuyWithAddOn, RebuyWithoutAddOn, ReEntry]

  return reEntryType == "None" ? (
    <div className="py-4 flex items-center justify-center text-sm text-primary font-medium">
      No Rebuy Info available
    </div>
  ) : reEntryType === "RebuyWithAddOn" ||
    reEntryType === "RebuyWithoutAddOn" ||
    reEntryType === "ReEntry" ? (
    <div>
      <div className="bg-foreground text-secondary rounded px-3 py-1 flex flex-wrap mb-3">
        {reEntryType == "ReEntry" ? (
          <InfoCard
            title="Rebuy Time"
            value="10 Seconds"
            secondaryValue={`First ${formatMinSec(
              selectedTourneyDetails?.reEntry?.reEntrySettings?.reentryLevel *
                levelDuration
            )} till level-${
              selectedTourneyDetails?.reEntry?.reEntrySettings?.reentryLevel
            }`}
          />
        ) : (
          <InfoCard
            title="Rebuy Time"
            value={
              tourneyStatus === TOURNEY_STATUS_CANCELLED
                ? "Cancelled"
                : `${
                    selectedTourneyDetails?.[
                      reEntryType == "RebuyWithAddOn"
                        ? "rebuyWithAddon"
                        : "rebuyWithOutAddon"
                    ]?.rebuySettings?.rebuyBuyin
                  } Seconds`
            }
            secondaryValue={
              tourneyStatus === TOURNEY_STATUS_CANCELLED
                ? ""
                : `First ${formatMinSec(
                    selectedTourneyDetails?.[
                      reEntryType == "RebuyWithAddOn"
                        ? "rebuyWithAddon"
                        : "rebuyWithOutAddon"
                    ]?.rebuySettings?.rebuyLevel * levelDuration
                  )} till level-${
                    selectedTourneyDetails?.[
                      reEntryType == "RebuyWithAddOn"
                        ? "rebuyWithAddon"
                        : "rebuyWithOutAddon"
                    ]?.rebuySettings?.rebuyLevel
                  }`
            }
          />
        )}
        {(reEntryType == "RebuyWithAddOn" ||
          reEntryType == "RebuyWithoutAddOn") && (
          <InfoCard
            title={"Re Threshold"}
            value={
              selectedTourneyDetails?.[
                reEntryType == "RebuyWithAddOn"
                  ? "rebuyWithAddon"
                  : "rebuyWithOutAddon"
              ]?.rebuySettings?.chipsBalanceForRebuyTrigger
            }
          />
        )}
        {reEntryType == "ReEntry" ? (
          <InfoCard
            title={"Rebuy Stack"}
            value={
              selectedTourneyDetails?.reEntry?.reEntrySettings?.chipsToBeGranted
            }
          />
        ) : (
          <InfoCard
            title={"Rebuy Stack"}
            value={
              selectedTourneyDetails?.[
                reEntryType == "RebuyWithAddOn"
                  ? "rebuyWithAddon"
                  : "rebuyWithOutAddon"
              ]?.rebuySettings?.chipsToBeGranted
            }
          />
        )}
        {reEntryType == "ReEntry" ? (
          <InfoCard
            title={"Max Rebuy Allowed"}
            value={
              selectedTourneyDetails?.reEntry?.reEntrySettings?.noOfReentry
            }
          />
        ) : (
          <InfoCard
            title={"Max Rebuy Allowed"}
            value={
              tourneyStatus === TOURNEY_STATUS_CANCELLED
                ? "Cancelled"
                : selectedTourneyDetails?.[
                    reEntryType == "RebuyWithAddOn"
                      ? "rebuyWithAddon"
                      : "rebuyWithOutAddon"
                  ]?.rebuySettings?.noOfRebuys
            }
          />
        )}
      </div>
      {reEntryType == "RebuyWithAddOn" && (
        <div className="bg-foreground text-secondary rounded px-3 py-1 flex flex-wrap mb-3">
          <InfoCard
            title="ADDON"
            value={
              selectedTourneyDetails?.rebuyWithAddon?.addonSettings
                ? "Allowed"
                : "Not Allowed"
            }
          />
          <InfoCard
            title={"ADDON DURATION"}
            value={
              tourneyStatus === TOURNEY_STATUS_CANCELLED
                ? "Cancelled"
                : `${selectedTourneyDetails?.rebuyWithAddon?.addonSettings?.addonTimeInterval}`
            }
          />
          <InfoCard
            title={"ADDON STACK"}
            value={
              selectedTourneyDetails?.rebuyWithAddon?.addonSettings
                ?.chipsToBeGranted
            }
          />
          {tourneyStartTime && (
            <InfoCard
              title={"ADDON START TIME"}
              value={
                tourneyStatus === TOURNEY_STATUS_CANCELLED
                  ? "Cancelled"
                  : format(
                      new Date(
                        Number(
                          tourneyStartTime * 1000 +
                            selectedTourneyDetails?.rebuyWithAddon
                              ?.rebuySettings?.rebuyLevel *
                              levelDuration
                        )
                      ),
                      "h:mm a"
                    )
              }
            />
          )}
        </div>
      )}
    </div>
  ) : null;
}

export default TourneyDetailsRebuyInfo;

const mockrebuyWithAddon = {
  rebuySettings: {
    rebuyEntryFee: 12,
    chipsBalanceForRebuyTrigger: 500,
    rebuyRake: 2,
    noOfRebuys: 5,
    doubleRebuy: true,
    rebuyLevel: 5,
    chipsToBeGranted: 1000,
    rebuyBuyin: 10,
  },
  addonSettings: {
    addonRake: 1,
    addonTimeInterval: 5,
    chipsToBeGranted: 1000,
    addonEntryFee: 10,
    addonBuyin: 9,
  },
};

// "reEntry": {
//       "reEntrySettings": {
//           "chipsToBeGranted": 1000,
//           "noOfReentry": 10,
//           "reEntryBuyIn": 10,
//           "reentryEntryFee": 11,
//           "reEntryBountyBuyIn": 0,
//           "reentryLevel": 10,
//           "reEntryRake": 1
//       }
// },

const data1 = [
  {
    title: "Rebuy Time",
    value: "15 Seconds",
    subTitle: "First 247 min till 25th level",
  },
  {
    title: "Rebuy Threshold",
    value: "0 Chips",
    subTitle: "",
  },
  {
    title: "Rebuy Stack",
    value: "15,000 Chips",
    subTitle: "",
  },
  {
    title: "Max Rebuy Allowed",
    value: "Unlimited Time",
    subTitle: "",
  },
];
const data2 = [
  {
    title: "ADDON",
    value: "Not Allowed",
    subTitle: "",
  },
  {
    title: "ADDON DURATION",
    value: "N/A",
    subTitle: "",
  },
  {
    title: "ADDON STACK",
    value: "N/A",
    subTitle: "",
  },
  {
    title: "ADDON START TIME",
    value: "N/A",
    subTitle: "",
  },
];
